import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const AiprizeBusinessActivitySchema = z
    .object({
        activity_type: z.enum(['primary', 'secondary']).optional(),
        code: z.string().optional(),
        codeType: z.string().optional(),
        description: z.string().optional(),
    })
    .strict();

export class AiprizeBusinessActivity extends FromSchema(AiprizeBusinessActivitySchema) {
    activity_type?: 'primary' | 'secondary';
    code?: string;
    codeType?: string;
    description?: string;
}
